(()=>{
 'use strict';
 if(String(window.FultonsDraftPreview?.themeId)!=='199663649151')return;
 const product={
  "id": "gid://shopify/Product/15888710336895",
  "title": "Clemmie Chair",
  "vendor": "Natuzzi Italia",
  "tags": [
    "brand-natuzzi-italia",
    "fultons-feasibility-test",
    "fultons-import-20260913",
    "not-for-sale",
    "type-armchairs-recliners"
  ],
  "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/natuzzi-italia-clemmie-chair-fabric.jpg?v=1789316203",
  "images": [
    {
      "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/natuzzi-italia-clemmie-chair-fabric.jpg?v=1789316203",
      "altText": "Clemmie Chair by Natuzzi Italia in grey fabric, three-quarter front view",
      "width": 3543,
      "height": 2362
    },
    {
      "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/natuzzi-italia-clemmie-chair-leather.jpg?v=1789316208",
      "altText": "Clemmie Chair by Natuzzi Italia in dark brown leather, three-quarter front view",
      "width": 3543,
      "height": 2362
    },
    {
      "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/natuzzi-italia-clemmie-chair-side.jpg?v=1789316278",
      "altText": "Clemmie Chair by Natuzzi Italia in grey fabric, side view",
      "width": 3543,
      "height": 2362
    },
    {
      "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/natuzzi-italia-clemmie-chair-room.jpg?v=1789316327",
      "altText": "Clemmie Chair by Natuzzi Italia with its matching footstool in a room setting; footstool available separately",
      "width": 1080,
      "height": 1080
    }
  ],
  "descriptionHtml": "<p>Designed by Maurizio Manzoni for Natuzzi Italia, Clemmie is a high-back armchair with a shaped headrest, slim arms and distinctive metal bridge feet. The front feet sit slightly higher than the rear to create its relaxed sitting position.</p><p>Available in leather or fabric, with fixed seat and back cushions and an internal wooden frame. Metal feet are offered in Glazed Nickel (75) or Black Chrome (78). A matching footstool is available separately.</p><ul>\n<li>Chair: W76 × D96 × H105 cm</li>\n<li>Seat height: 45 cm</li>\n<li>Model 3125, version 012</li>\n</ul><p><a href=\"https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-natuzzi-clemmie-chair-3125-specification.pdf?v=1789316490\" target=\"_blank\" rel=\"noopener\">Download the Clemmie technical specification (PDF)</a></p>",
  "collectionIds": [
    "704334037375"
  ]
};
 const id='15888710336895';
 window.FultonsDraftProducts=[...(window.FultonsDraftProducts||[]).filter(p=>String(p.id).split('/').pop()!==id),product];
 const options={
  "heading": "Upholstery & options",
  "kind": "chair",
  "fromPrice": 1935,
  "options": [
    {
      "label": "Clemmie high-back chair",
      "sizeLabel": "W76 × D96 × H105 cm",
      "prices": {
        "Fabric": 1935,
        "Leather": 2065
      },
      "thumbnail": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/natuzzi-italia-clemmie-chair-fabric.jpg?v=1789316203",
      "thumbnailAlt": "Clemmie Chair in grey fabric",
      "note": "Metal feet in Glazed Nickel or Black Chrome. Matching footstool available separately."
    }
  ],
  "note": "Starting prices are for fabric category 70 or leather category 15; other upholstery choices may cost more."
};
 const applyOptions=()=>{
  window.FultonsProductOptions={...(window.FultonsProductOptions||{}),[id]:options};
  document.dispatchEvent(new CustomEvent('fultons:catalogue-updated'));
 };
 applyOptions();
 if(document.readyState!=='complete')document.addEventListener('DOMContentLoaded',applyOptions,{once:true});
})();
